// src/components/transactions/WithdrawHistoryTable.jsx
import React from "react";
import { doc, updateDoc, increment } from "firebase/firestore";
import { db } from "../../firebase";
import toast from "react-hot-toast";

export default function WithdrawHistoryTable({ withdrawals, user }) {
  const handleCancel = async (w) => {
    if (w.status !== "pending") return;
    const userRef = doc(db, "users", user.uid);
    await updateDoc(userRef, { balance: increment(w.amount) });
    await updateDoc(doc(db, "withdraw_requests", w.id), {
      status: "cancelled",
      processedAt: new Date(),
    });
    toast("Withdrawal cancelled, funds returned.");
  };

  if (!withdrawals || withdrawals.length === 0) {
    return (
      <div className="text-center text-slate-400 py-6">
        No withdrawal requests yet.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm bg-[#232c3c] rounded-xl">
        <thead>
          <tr className="text-lime-200 font-semibold text-left">
            <th className="py-2 px-2">Amount</th>
            <th className="py-2 px-2">Status</th>
            <th className="py-2 px-2">Date</th>
            <th className="py-2 px-2">TXID</th>
            <th className="py-2 px-2">Action</th>
          </tr>
        </thead>
        <tbody>
          {withdrawals.map((w) => (
            <tr key={w.id} className="border-b border-slate-800 last:border-0">
              <td className="py-2 px-2">${Number(w.amount).toFixed(2)}</td>
              <td className="py-2 px-2">
                <span
                  className={
                    w.status === "pending"
                      ? "text-yellow-400"
                      : w.status === "processing"
                      ? "text-blue-400"
                      : w.status === "done"
                      ? "text-lime-400"
                      : "text-pink-400"
                  }
                >
                  {w.status?.charAt(0).toUpperCase() + w.status?.slice(1)}
                </span>
              </td>
              <td className="py-2 px-2">
                {/* Handle both Firestore Timestamp and JS Date */}
                {w.requestedAt
                  ? w.requestedAt.seconds
                    ? new Date(w.requestedAt.seconds * 1000).toLocaleString()
                    : new Date(w.requestedAt).toLocaleString()
                  : "-"}
              </td>
              <td className="py-2 px-2">{w.txId || "-"}</td>
              <td className="py-2 px-2">
                {w.status === "pending" ? (
                  <button
                    className="text-pink-400 underline"
                    onClick={() => handleCancel(w)}
                  >
                    Cancel
                  </button>
                ) : (
                  "-"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
